import { $api } from "../../../../../services/request.config";
import { getEligibleDelegateStructsAction } from "../getEligibleDelegateStructs.action";

export const getEligibleDelegateStructsThunkAction = (
    { setIsLoading, setLoadError },
) => async (dispatch) => {
    try {
        setIsLoading(true);
        setLoadError(false);
        const response = await $api("v1/manager/delegations/eligible-delegates/structs");

        if (response.status === 200) {
            dispatch(getEligibleDelegateStructsAction(response.data));
        }
        setIsLoading(false);
    } catch (error) {
        setIsLoading(false);
        if (!error.response || error.response.status >= 500) {
            setLoadError(true);
        } else {
            dispatch(getEligibleDelegateStructsAction([]));
        }
    }
};